<script setup lang="ts">
    import { computed, ref, toRef } from 'vue'
    import type { PropType } from 'vue'
    import type { CriteriaFromStringBuilderViewModel } from "@Criteria/Hierarchies/Components/CriteriaFromStringBuilder"

    // ---------------- props / emits ----------------

    const props = defineProps({
        viewModel: {
            type: Object as PropType<CriteriaFromStringBuilderViewModel>,
            required: true
        }
    })

    const emit = defineEmits<{
        (e: 'create-criteria', parentId: number, criteriaString: string | null): void
    }>()

    // ---------------- state ----------------

    const vm = toRef(props, 'viewModel')

    const criteriaString = ref<string | null>(null)

    // ---------------- computed ----------------

    const opened = computed(() => vm.value.isOpen)
    const parentName = computed(() => vm.value.parentName)

    // ---------------- actions ----------------

    function handleFormSubmit()
    {
        emit('create-criteria', vm.value.parentId!, criteriaString.value)
        criteriaString.value = null
    }

    function close()
    {
        vm.value.close()
    }
</script>


<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Add criteria under: {{ parentName }}</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>
                    <div class="modal-body">

                        <form id="criteria-from-string-builder-form" @submit.prevent="handleFormSubmit">
                            <div class="form-group">
                                <label>Enter criteria below, each on a new line:</label>
                                <textarea v-model.trim="criteriaString" class="form-control" rows="8" required></textarea>
                            </div>
                        </form>
                    </div>

                    <div class="modal-footer">
                        <button type="button" @click="close" class="btn btn-outline-secondary">Close</button>
                        <button type="submit" form="criteria-from-string-builder-form" class="btn btn-primary">Create</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>